import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#2850DA',
                contentColor: '#1d1d1d',
                strongBlue: '#2d5d84',
                strongOrange: '#eb7525',
                strongPink: '#c53c44',
                linkHoverColor:'#CCB7FF',
            },
        },
    }
});